//var checkSessionInterval;

window.App = {
    init: function () {
        $(function () {
            // init select box in table
            (function () {
                [].slice.call(document.querySelectorAll('#accordion select.cs-select')).forEach(function (el) {
                    new SelectFx(el);
                });
            })();

            $("#keyword").keyup(function (event) {
                if (event.keyCode == 13) {
                    $("#search-btn").click();
                }
            });

            $("#keywords").keyup(function (event) {
                if (event.keyCode == 13) {
                    $(".search-c").click();
                }
            });


            $('#search').on('click', function () {
                if ($('#search-section').hasClass('active-search')) {
                    $('#search-section').slideUp();
                    $('#search-section').removeClass('active-search');
                }
                else {
                    $('#search-section').slideDown();
                    $('#search-section').addClass('active-search');
                }
            });

            // Prevent space input in email fields
            $("input[name*=email]").keydown(function (event) {
                if (event.keyCode == 32) {
                    event.preventDefault();
                }
            });

            // If the document is clicked somewhere
            $(document).on("mousedown", function (event) {
                // If the clicked element is not the menu
                if (!($(event.target).parents(".cs-select").length > 0)) {
                    $("div.cs-select.cs-active").removeClass('cs-active');
                }
            });
            /* Reused on various pages */
            App.sidebarToggle();
            App.handleDoubleClickMobile();
            // Every minute call the check session interval
            // checkSessionInterval = setInterval(App.checkUserSession, 10000);

            $('body').on('click', '.save-rylie-template', e => {
                e.preventDefault();
                const $el = $(e.target);
                App._handleTemplateExport($el.attr('data-id'), $el.attr('data-type'), $el.attr('data-autosigma'));
            });

            // Upload List button check
            $('body').on('click', '#upload-list-button', e => {
                e.preventDefault();
                if ($("#static-list-toolbar").length == 0) {
                    // Not in the precreated filters page
                    var href = $(e.target).attr('href');
                    window.location.href = href;
                } else {
                    var staticToolbar = $("#static-list-toolbar");
                    if ($(staticToolbar).css('display') == 'none') {
                        // In the page, but active tab is not static list, modal will not be displayed correctly
                        $('#preCreatedFiltersTab a[href="#staticListTab"]').tab('show');
                    }
                    // Once ensured in the correct tab, trigger CSV Upload Modal
                    var $modal = $('#upload-modal');
                    // Disable the click outside closing the modal, as it often accidentally clicked when navigating
                    $modal.modal({ backdrop: 'static', keyboard: false });
                }

            });
        });
    },

    _handleTemplateExport: function (id, type, isAutosigmaTemplate) {
        App.loadAjax();
        axios.post('/save-shared-template', {
            id: id,
            type: type,
            autosigma: !!isAutosigmaTemplate
        }).then(response => {
            if (response.data.name) {
                return Swal.fire(`Template was successfully saved in Rylie as <strong>${response.data.name}</strong>`, '', 'success');
            }

            Swal.fire({
                title: `Saving template to Rylie`,
                showCancelButton: true,
                html: response.data,
                width: '26rem',
                confirmButtonText: `Save`,
                cancelButtonText: 'Cancel',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    App.loadAjax();
                    axios.post('/save-shared-template', {
                        id: id,
                        type: type,
                        is_primary: $('#template_type_primary').is(':checked'),
                        autosigma: !!isAutosigmaTemplate
                    }).then(response => {
                        Swal.fire(`Template was successfully saved in Rylie as <strong>${response.data.name}</strong>`, '', 'success');
                    }).catch(error => {
                        Swal.fire(error.response.data.message, '', 'error');
                    }).finally(_ => {
                        App.loadAjax('unmask');
                    })
                },
                allowOutsideClick: () => !Swal.isLoading()
            });
        }).catch(error => {
            Swal.fire(error.response.data.message, '', 'error');
        }).finally(_ => {
            App.loadAjax('unmask');
        });
    },

    /** Fallback of ondblclick on devices that do not suport it */
    handleDoubleClickMobile: function () {
        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            $("[ondblclick]").on('click.dblclick', function () {
                App.EnableEditNew($(this).parents('tr'));
            });
        }
    },
    /**
     * Toggles sidebar
     * Sidebar by default is shown*/
    sidebarToggle: function () {
        var bodyDom = $('body');
        bodyDom.on('click', '#sidebar_toggle_show', function () {
            bodyDom.removeClass('sidebar-hide').addClass('sidebar-show');
        });

        bodyDom.on('click', '#sidebar_toggle_hide', function () {
            bodyDom.removeClass('sidebar-show').addClass('sidebar-hide');
        });

        if ($(window).width() < 767) {
            $('#sidebar_toggle_hide').trigger('click');
        }
    },
    /**
     * This function always calls the check session on the users controller
     * in order to log a user out automatically when his/her account has been
     * deleted. If not deleted, we clear the interval;
     */
    /*checkUserSession: function () {
     $.get('/checkSession', function (response) {
     if (response.status === 1) {
     window.location.href = '/deactivated';
     } else if (response.status === 2) {
     clearInterval(checkSessionInterval);
     }
     });
     },*/

    loadAjax: function (type, element) {
        if (type === 'unmask') {
            $('body').removeClass('overlay-loader');
        } else if (typeof element !== 'undefined') {
            element.append('<div id="screen-load"><img src="../images/loader.gif" class="ajax-loader"/></div>');
        } else {
            $('body').addClass('overlay-loader');
        }
    },

    search: function (el, search_role) {
        var keyword = $('#keyword').val();
        if (keyword.length === 0) {
            $('#keyword').focus();
            return;
        }
        if (search_role === undefined) {
            search_role = 'admin';
        }

        if (search_role == 'admin'){
            var url = '/customers';
        } else {
            var url = '/agents_customers';
        };

        // Params that the URL was loaded with
        var existing_params = App.getPageParams();

        var params_string = '';

        // Build a query string out of existing params if any
        if (existing_params.length && search_role == 'admin') {
            params_string = '?' + existing_params[0].key + '=' + existing_params[0].value;

            for (var i = 1; i < existing_params.length; i++) {
                var curr = existing_params[i];

                if (curr.key != 'keyword') {
                    params_string += '&' + curr.key  + '=' + curr.value;
                }
            }
        }

        // Finally add keyword param to the url
        // By retaining other params together with the keyword param
        // during a search, we are able to utilise search functionality
        // when creating lists
        url += (params_string == '') ? ('?keyword=' + keyword) : (params_string + '&keyword=' + keyword);

        window.location.href = url;
    },

    selectSystem: function (system_name) {
        $.ajax({
            type: "POST",
            async: true,
            url: '/setSelectedSystem',
            data: {selected_system: system_name},
            success: function (result) {
                window.location.href = 'dashboard';
            }
        });
    },
    openFacebookReports: function(system_name) {
        $.ajax({
            type: "POST",
            async: true,
            url: '/setSelectedSystem',
            data: {selected_system: system_name},
            success: function (result) {
                window.location.href = '/mail/reports';
            }
        });
    },
    /* enabling edit in table view according to the rules
     * params: table - table element for which we edit
     * allIds - element where we get all ids for table
     * globalVar - global variable where we store ids according to page we are on
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    InputCahnge: function (table, allIds, globalVar) {
        var allAgentListsIds = ((typeof allIds.val() == 'string') ? allIds.val() : '').split(',');
        var select_all = document.querySelectorAll('.select--all');
        var select_allop = document.querySelectorAll('.select--allop');

        $('input[type=checkbox]').change(function () {
            if (table.attr('id') == 'customers' || table.attr('id') == 'contacts')
                var id = $(this).attr('value');
            else
                var id = $(this).attr('id');

            if ($(this).prop('checked')) {
                // Add the element to the agent_list if its is not already added
                if ($.inArray(id, globalVar) == -1) {
                    globalVar.push(id);
                }

                // Set the select all button to the appropriate label
                if (table.find('input[type="checkbox"]:not(:checked)').length > 0) {
                    $('#select_all span.text').text('Select All On Page');
                    _setSelectText(select_allop, false, true);
                } else {
                    $('#select_all span.text').text('Unselect All On Page');
                    _setSelectText(select_allop, true, true);
                }

                // Set the select all records button to the appropriate label
                if (globalVar.length == allAgentListsIds.length) {
                    $('#select_all_records').find('span.text').text('Unselect All');
                    _setSelectText(select_all, true, false);
                } else {
                    $('#select_all_records').find('span.text').text('Select All');
                    _setSelectText(select_all, false, false);
                }
            } else {
                // Remove the element from the globalVar if its is already added
                if ($.inArray(id, globalVar) != -1) {
                    globalVar.splice(globalVar.indexOf(id), 1);
                }

                $('#select_all span.text').text('Select All On Page');
                $('#select_all_records').find('span.text').text('Select All');

                _setSelectText(select_allop, false, true);
                _setSelectText(select_all, false, false);
            }
        });
    },

    /* enabling edit intable view according to the rules
     * params: el - table element for which we edit
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    // EnableEdit: function (el) {
    //
    //     // prevent second double click if the row is still active
    //     if ($(el).find('input').prop('readonly') == false) return;
    //
    //     // checks if table has last select column if not adds it
    //     if ($(el).find('td.select-col').hasClass('hidden')) {
    //         $(el).parents('table').find('th.selectHead').removeClass('hidden');
    //         $(el).parents('table').find('td.select-col').removeClass('hidden');
    //     }
    //
    //     // comment column disable from edit
    //     $(el).find('input').prop('readonly', false);
    //     // outcome column enable from edit
    //     $(el).find('.cs-select').parent().css({"position": "relative", "z-index": "1", "background-color": ""});
    //     $(el).find('.cs-select').css({"z-index": "2", "background-color": "", "pointer-events": "auto"});
    //
    //     // next call column edit for agent side
    //     if ($(el).find('.next-call-col').length > 0) {
    //         $(el).find("input[name*='next_call']").prop('readonly', false);
    //         $(el).find("input[name*='next_call']").datetimepicker({
    //             dateFormat: "yy-mm-dd",
    //             timeFormat: "HH:mm",
    //             minDate: new Date()
    //         });
    //     }
    //
    //     // adding action icons for save and cancel
    //     $(el).find('.comment-save').css({"display": "block"});
    //     $(el).find('.comment-cancel').css({"display": "block"});
    //
    //     // toggling checkbox if exists to be replaced with icons
    //     if ($(el).find('.select-col input').length > 0) {
    //         $(el).find('.select-col input').toggle();
    //         $(el).find('.select-col label').toggle();
    //     }
    //
    //     // adding icon actions
    //     $(el).find('.select-col').append('<span onclick="App.CancelEdit($(this).parents(\'tr\'));return false;" class="comment-cancel"></span>');
    //     $(el).find('.select-col').append('<span onclick="App.SaveEdit($(this).parents(\'tr\'));return false;" class="comment-save"></span>');
    // },

    /* enabling edit intable view according to the rules
     * params: el - table element for which we edit
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    EnableEditNew: function (el) {

        // prevent second double click if the row is still active
        if ($(el).find('input').prop('readonly') == false) return;

        // checks if table has last select column if not adds it
        if ($(el).find('td.select-col').hasClass('hidden')) {
            $(el).parents('table').find('th.selectHead').removeClass('hidden');
            $(el).parents('table').find('td.select-col').removeClass('hidden');
        }

        // comment column disable from edit
        $(el).find('input').prop('readonly', false);
        // outcome column enable from edit
        var trDom = $(el).find('.cs-select').closest("tr");
        /** fixing dropdown cut issue */
        if (trDom.is("tr:last")) {
            trDom.closest(".table").css("margin-bottom", "265px");
        }
        var index = trDom.index();
        var zIndex = 100 - index;
        $(el).find('.cs-select').parent().css({"position": "relative", "z-index": "" + zIndex, "background-color": ""});
        $(el).find('.cs-select').css({"z-index": "2", "background-color": "", "pointer-events": "auto"});

        // next call column edit for agent side
        if ($(el).find('.next-call-col').length > 0) {
            var times = new Date(moment().utcOffset('-0600').format('YYYY/MM/DD h:mm a'));

            $(el).find("input.next-call-col").prop('readonly', false);

            $(el).find("input.next-call-col").datetimepicker({
                dateFormat: "yy-mm-dd",
                timeFormat: "hh:mm tt",
                minDate: times,
                hour: times.getHours(),
                minute: times.getMinutes(),
                second: times.getSeconds()
            });
        }

        // adding action icons for save and cancel
        $(el).find('.comment-save').css({"display": "block"});
        $(el).find('.comment-cancel').css({"display": "block"});

        // toggling checkbox if exists to be replaced with icons
        if ($(el).find('.select-col input').length > 0) {
            $(el).find('.select-col input').toggle();
            $(el).find('.select-col label').toggle();
        }

        // adding icon actions
        $(el).find('.select-col').append('<span onclick="App.CancelEdit($(this).parents(\'tr\'));return false;" class="comment-cancel"></span>');
        $(el).find('.select-col').append('<span onclick="App.SaveEditNew($(this).parents(\'tr\'));return false;" class="comment-save"></span>');
    },

    /* canceling edit intable view according to the rules
     * params: el - table element for which we edit
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    CancelEdit: function (el) {
        var c = 'Please Select';

        $(el).find('#outcomeone').find('option').each(function (i, opt) {
            if (opt.defaultSelected)
                c = $(this).val();
        });

        $(el).find('#outcomeone').selectpicker('val', c);

        // remembering default value for comment column
        $(el).find('input[name^="comment"]').val($(el).find('input[name^="comment"]').prop("defaultValue"));
        var callId = $(el).find('input[name^="next_call"]').attr('call-id');
        var id = $(el).find('input[name^="next_call"]').attr('id');
        var name = $(el).find('input[name^="next_call"]').attr('name');
        var input = '<input type="text" call-id="'+callId+'" size="10" id="'+id+'" name="'+name+'" class="next-call-col" ' +
            'value="'+$(el).find('input[name^="next_call"]').prop("defaultValue")+'" ' +
            'onfocusout="return false" ' +
            'onfocus="App.BlurInput(this)" readonly="readonly">';
        $(el).find('input[name^="next_call"]').parent().html(input);

        // adding hidden class to action icons and removing them from edit
        if ($(el).find('td.select-col').hasClass('hidden')) {
            $(el).parents('table').find('th.selectHead').removeClass('hidden');
            $(el).parents('table').find('td.select-col').removeClass('hidden');
        } else {
            if (!$(el).find('td.select-col').hasClass('hidden')) {
                $(el).parents('table').find('th.selectHead').removeClass('hidden');
                $(el).parents('table').find('td.select-col').removeClass('hidden');
            } else {
                $(el).parents('table').find('th.selectHead').addClass('hidden');
                $(el).parents('table').find('td.select-col').addClass('hidden');
            }
        }
        //check if theres no comment cancel then hide

        // comment column disable from edit
        $(el).find('input[type="text"]').prop('readonly', true);

        // outcome column disable from edit
        $(el).find('.cs-select').parent().css({
            "position": "relative",
            "z-index": "0",
            "background": "rgb(235, 235, 228)"
        });
        $(el).find('.cs-select').css({"z-index": "-1", "pointer-events": "none"});
        $(el).find('.bootstrap-select').removeClass('open'); //close drop-down


        // next call column for agent disable for edit
        if ($(el).find("input[name*='next_call']").length > 0)
            $(el).find("input[name*='next_call']").prop('readonly', true);

        // remove back the checkbox if exists
        if ($(el).find('.comment-cancel').length > 0) {
            $(el).find('.select-col input').toggle();
            $(el).find('.select-col label').toggle();
        }

        // remove icons for actions
        $(el).find('.comment-save').remove();
        $(el).find('.comment-cancel').remove();
        //check if there's no comment cancel then hide column if applicable
        if (($(el).parents('table').find('.comment-cancel').length <= 0) && ($(el).parents('table').find('.select-col input').length <= 0)) {
            $(el).parents('table').find('th.selectHead').addClass('hidden');
            $(el).parents('table').find('td.select-col').addClass('hidden');
        }
    },

    /* saving after edit in table view according to the rules
     * params: el - tr element for which we edit
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    // SaveEdit: function (el) {
    //     var token = $('[name="_token"]').val();
    //     var tr = $(el);
    //
    //     // params for successfull save
    //     var comment = tr.find("input[name*='comment']").val();
    //     var next_call = tr.find("input[name*='next_call']").val();
    //     var schedule_date = tr.find("input[name*='appointment_schedule']").val();
    //
    //     var sort = $('#sortby').val();
    //     var order = $('#orderby').val();
    //
    //     var user_id = tr.attr('user-id');
    //     var outcome = tr.find("#outcomeone").val();
    //     var client_id = tr.attr('client-id');
    //     var call_id = tr.attr('call-id');
    //
    //     App.loadAjax();
    //
    //
    //     //get the save url based on system type
    //     var url = '';
    //     var currUrl = window.location.href.toString().toLowerCase();
    //     var side = 'sales';
    //     if (currUrl.indexOf('service') > 0 || currUrl.indexOf('past_due_cust') > 0) {
    //         url = 'serviceCalls/saveEdit';
    //         side = 'service';
    //     } else {
    //         url = 'calls/saveEdit';
    //     }
    //
    //     // ajax call for refreshing after successfully save
    //     $.ajax({
    //         type: "POST",
    //         async: true,
    //         headers: {'X-CSRF-TOKEN': token},
    //         url: url,
    //         data: {
    //             client_id: client_id,
    //             user_id: user_id,
    //             call_id: call_id,
    //             outcome: outcome,
    //             schedule_date: schedule_date,
    //             comment: comment,
    //             next_call: next_call
    //         },
    //         success: function (result) {
    //             if (new RegExp('[\?&]result=([^&#]*)').exec(window.location.href)) {
    //                 App.CancelEdit(el);
    //             } else {
    //                 var table = tr.parents('table').attr('id');
    //
    //                 // refreshing according to table id
    //                 if (table == 'hot-leads') {
    //                     HotLeads.RefreshLeads(el, sort, order);
    //                 } else if (table == 'due-today') {
    //                     DueToday.RefreshDueToday(el, sort, order);
    //                 } else if (table == 'clients') {
    //                     (side == 'service') ? ServiceClients.RefreshClients(el, sort, order) : Clients.RefreshClients(el, sort, order);
    //                 } else if (table == 'list-clients') {
    //                     ListAgent.RefreshListAgentClients(el, sort, order);
    //                 } else if (table == 'past-due-cust') {
    //                     PastDueCust.RefreshClients(el, sort, order);
    //                 } else if (table == 'calls') {
    //                     (side == 'service') ? ServiceCalls.RefreshCalls(el, sort, order) : Calls.RefreshCalls(el, sort, order);
    //                 } else if (table == 'sales-query') {
    //                     QueryFilters.RefreshSalesQuery(el, sort, order);
    //                 } else if (table == 'service-query') {
    //                     ServiceQueryFilters.RefreshServiceQuery(el, sort, order);
    //                 } else if (table == 'todays-appointments') {
    //                     (side == 'service') ? TodaysAppointmentsServices.RefreshTodaysAppointments(el, sort, order) : TodaysAppointments.RefreshTodaysAppointments(el, sort, order);
    //                 } else if (table == 'customers') {
    //                     Customers.RefreshClients(el, sort, order);
    //                 }
    //             }
    //             App.loadAjax('unmask');
    //         }
    //     });
    // },
    /* saving after edit in table view according to the rules
     * params: el - tr element for which we edit
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    SaveEditNew: function (el) {
        var token = $('[name="_token"]').val();
        var tr = $(el);

        // params for successfull save
        var comment = tr.find("input[name*='comment']").val();
        var next_call = tr.find("input[name*='next_call']").val();
        if ($("#appointment_date").length > 0) {
            var schedule_date = $("#appointment_date").length > 1 ? $($("#appointment_date")[0]).val() : $("#appointment_date").val();
        } else {
            var schedule_date = $('input[name="appointment_schedule"]').length > 1 ? $($('input[name="appointment_schedule"]')[0]).val() : $('input[name="appointment_schedule"]').val();
        }

        var sort = $('#sortby').val();
        var order = $('#orderby').val();

        var user_id = tr.attr('user-id');
        var outcome = tr.find("#outcomeone").val();
        var client_id = tr.attr('client-id');
        var call_id = tr.attr('call-id');

        App.loadAjax();


        //get the save url based on system type
        var url = '';
        var currUrl = window.location.href.toString().toLowerCase();
        var side = 'sales';
        if (currUrl.indexOf('service') > 0 || currUrl.indexOf('past_due_cust') > 0) {
            url = '/saveEditNew';
            side = 'service';
        } else {
            url = '/saveEditNew';
        }

        // ajax call for refreshing after successfully save
        $.ajax({
            type: "POST",
            async: true,
            headers: {'X-CSRF-TOKEN': token},
            url: url,
            data: {
                client_id: client_id,
                user_id: user_id,
                call_id: call_id,
                outcome: outcome,
                schedule_date: schedule_date,
                comment: comment,
                next_call: next_call
            },
            success: function (result) {
                if (new RegExp('[\?&]result=([^&#]*)').exec(window.location.href)) {
                    App.CancelEdit(el);
                } else {
                    // var table = tr.parents('table').attr('id');

                    // refreshing according to table id
                    // if (table == 'hot-leads') {
                    // 	HotLeads.RefreshLeads(el, sort, order);
                    // } else if (table == 'due-today') {
                    // 	DueToday.RefreshDueToday(el, sort, order);
                    // } else if (table == 'clients') {
                    // 	(side == 'service') ? ServiceClients.RefreshClients(el, sort, order) : Clients.RefreshClients(el, sort, order);
                    // } else if (table == 'list-clients') {
                    // 	ListAgent.RefreshListAgentClients(el, sort, order);
                    // } else if (table == 'past-due-cust') {
                    // 	PastDueCust.RefreshClients(el, sort, order);
                    // } else if (table == 'calls') {
                    // 	(side == 'service') ? ServiceCalls.RefreshCalls(el, sort, order) : Calls.RefreshCalls(el, sort, order);
                    // } else if (table == 'sales-query') {
                    // 	QueryFilters.RefreshSalesQuery(el, sort, order);
                    // } else if (table == 'service-query') {
                    // 	ServiceQueryFilters.RefreshServiceQuery(el, sort, order);
                    // } else if (table == 'todays-appointments') {
                    // 	(side == 'service') ? TodaysAppointmentsServices.RefreshTodaysAppointments(el, sort, order) : TodaysAppointments.RefreshTodaysAppointments(el, sort, order);
                    // } else if (table == 'customers') {
                    Customers.RefreshClients(el, sort, order);
                    // }
                }
                App.loadAjax('unmask');
            }
        });
    },
    /* table reset edit features
     * params: table which is reseting
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    tableAfterEdit: function (table, sort, order) {

        table.find('#' + sort + ' .sort_' + order).addClass('sort_' + order);

        order == 'desc' ? 'asc' : 'desc';

        table.find('#' + sort + ' .sort_' + order).removeClass('sort_' + order);
        table.find('#' + sort).attr('order-by', order);

        // $('#sortby').val(sort);
        // $('#orderby').val(order);

        // editing in table config
        if (table.find("input[name*='comment']").length > 0) {
            table.find("input[name*='comment']").prop('readonly', true);
            table.find("input[name*='next_call']").prop('readonly', true);
            table.find('.cs-select').parent().css({
                "position": "relative",
                "z-index": "0",
                "background": "rgb(235, 235, 228)"
            });
            table.find('.cs-select').css({"z-index": "-1", "pointer-events": "none"});
        }

        formatAllNumbers();
    },

    /* focusing and bluring for clicked element
     * params: el - clicked element
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    BlurInput: function (el) {
        if (el.readOnly)
            el.blur();
        window.setTimeout(function () {
            if (!el.readOnly)
                el.focus();
        }, 150);
    },

    print: function (type) {
        App.loadAjax();

        var currIds = $('table input:checked');
        var selected = [];

        $.each(currIds, function () {
            if ($.inArray($(this).attr('id'), ids) == -1) {
                selected.push($(this).attr('id'));
            }
        });

        // Get the sort and order
        var sort = $('#sortby').val();
        var order = $('#orderby').val();
        var token = $('[name="_token"]').val();
        var data = {
            sort: sort,
            order: order
        };

        if (type == 0) {
            if (ids.length > 0) {
                $.merge(selected, ids);
                var link = window.location.protocol + '//' + window.location.host + '/getPrintView';

                data.type = 1;
                data.selected_ids = selected.join(', ');
            } else if (callIds.length > 0) {
                var link = window.location.protocol + '//' + window.location.host + '/getPrintView';

                data.type = 2;
                data.selected_ids = callIds.join(', ');
            }
        } else if (type == 1) {
            var pageNo = $('.pagination li.active span').text();
            var link = window.location.protocol + '//' + window.location.host + '/allClients';

            var keyword = $('input[name=search-keyword]').val();

            if (keyword) {
                data.keyword = keyword;
            }

            data.print = true;
            data.page = pageNo;
        } else {
            var pageNo = $('.pagination li.active span').text();
            var link = window.location.protocol + '//' + window.location.host + window.location.href.toString().split(window.location.host)[1];

            var keyword = $('input[name=search-keyword]').val();

            if (keyword) {
                data.keyword = keyword;
            }

            data.print = true;
            data.page = pageNo;
        }

        var printWin = window.open('', '', 'width=' + window.innerWidth + ',height=' + window.innerHeight);

        $.ajax({
            type: "POST",
            headers: {'X-CSRF-TOKEN': token},
            data: data,
            url: link,
            success: function (response) {
                App.loadAjax('unmask');

                printWin.document.open();
                printWin.document.write(response);
                printWin.document.close();

                // Wait for the page to load, and after that we print and close the window
                printWin.focus();
                printWin.print();
                printWin.close();
            }
        });
    },

    /* on single row click view call dialog info
     * params: type is used to determine if should refresh whole dialog or just table in it
     * el is element clicked, event is current event for that element clicked
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    // ViewCalls: function (el, type, event, side) {
    //     if (typeof event == 'undefined') {
    //         event = document.createEvent('Event');
    //     }
    //
    //     // checking if edit is on and forbiding event on selecting dropdown, so it works properly
    //     if (
    //         $(event.target).find('.cs-select').length ||
    //         ($(event.target).closest('.cs-select').length && $(event.target).closest('.cs-select').parent().closest('td').length)
    //     )
    //         return false;
    //
    //     // getting ids from tr element
    //     var token = $('[name="_token"]').val();
    //     var client_id = $(el).attr('client-id');
    //     var user_id = $(el).attr('user-id');
    //
    //     App.loadAjax();
    //
    //     $.ajax({
    //         type: "POST",
    //         headers: {'X-CSRF-TOKEN': token},
    //         url: side == 'sales' ? '/calls/callsView' : '/serviceCalls/serviceCallsView',
    //         dataType: 'html',
    //         data: {
    //             client_id: client_id,
    //             user_id: user_id,
    //             type: type
    //         },
    //         success: function (result) {
    //             App.loadAjax('unmask');
    //
    //             // calling dialog for calls
    //             $('body').append(result);
    //             $('#view-call').dialog({
    //                 dialogClass: 'dialog-position',
    //                 width: 800,
    //                 modal: true,
    //                 buttons: {
    //                     Save: {
    //                         text: 'Add New Call Log',
    //                         class: 'btn btn-custom assign-btn pull-right',
    //                         click: function () {
    //                             // making call dialog init
    //                             $(this).dialog("close");
    //                             $('#view-call').remove();
    //                             App.MakeCall(el, side);
    //                         }
    //                     },
    //                     Cancel: {
    //                         text: 'Cancel',
    //                         class: 'btn btn-custom cancel-btn pull-left',
    //                         click: function () {
    //                             $(this).dialog("close");
    //                         }
    //                     }
    //                 },
    //                 open: function () {
    //
    //                     // order buttons in dialog
    //                     $('.cancel-btn').prepend('<span class="cancel-icon"></span>');
    //                     $('.ui-dialog-buttonset').find('.assign-btn').prepend('<span class="assign-icon"></span>');
    //                 },
    //                 close: function () {
    //                     $(this).dialog("close");
    //                     $('#view-call').remove();
    //                 }
    //             });
    //         }
    //     });
    // },

    /* saves calls to db
     * params: el is element clicked, event is current event for that element clicked
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    // MakeCall: function (el, side) {
    //     // getting required info fot dialog display
    //     var token = $('[name="_token"]').val();
    //     var client_id = $(el).attr('client-id');
    //     var user_id = $(el).attr('user-id');
    //
    //     // Get the sort and order
    //     var sort = $('#sortby').val();
    //     var order = $('#orderby').val();
    //
    //     App.loadAjax();
    //
    //     // initializing ajax dialog call
    //     $.ajax({
    //         type: "GET",
    //         url: side == 'sales' ? '/calls/create' : '/serviceCalls/create',
    //         data: {
    //             client_id: client_id,
    //             user_id: user_id
    //         },
    //         success: function (result) {
    //             App.loadAjax('unmask');
    //
    //             $('body').append(result);
    //
    //             $('#create-call').dialog({
    //                 dialogClass: 'dialog-position',
    //                 width: 400,
    //                 position: {my: "top", at: "top+150"},
    //                 modal: true,
    //                 buttons: {
    //                     Save: {
    //                         text: 'Save',
    //                         class: 'btn btn-custom assign-btn pull-right',
    //                         click: function () {
    //                             // get form data for save call
    //                             var form = $('#create-call').find('form');
    //                             var data = $(form).serialize();
    //
    //                             App.loadAjax();
    //
    //                             $.ajax({
    //                                 type: "POST",
    //                                 headers: {'X-CSRF-TOKEN': token},
    //                                 url: side == 'sales' ? '/calls/store' : '/serviceCalls/store',
    //                                 data: data,
    //                                 success: function (result) {
    //                                     $('#create-call').dialog('close');
    //
    //                                     var table = $('#table-section').find('table').attr('id');
    //
    //                                     // refreshing according to table id
    //                                     if (table == 'hot-leads') {
    //                                         HotLeads.RefreshLeads(el, sort, order);
    //                                     } else if (table == 'due-today') {
    //                                         (side == 'sales') ? DueToday.RefreshDueToday(el, sort, order) : DueTodayServices.RefreshDueToday(el, sort, order);
    //                                     } else if (table == 'clients') {
    //                                         (side == 'sales') ? Clients.RefreshClients(el, sort, order) : ServiceClients.RefreshClients(el, sort, order);
    //                                     } else if (table == 'calls') {
    //                                         (side == 'sales') ? Calls.RefreshCalls(el, sort, order) : ServiceCalls.RefreshCalls(el, sort, order);
    //                                     } else if (table == 'service-query') {
    //                                         ServiceQueryFilters.RefreshServiceQuery(el, sort, order);
    //                                     } else if (table == 'list-clients') {
    //                                         ListAgent.RefreshListAgentClients(el, sort, order);
    //                                     } else if (table == 'sales-query') {
    //                                         QueryFilters.RefreshSalesQuery(el, sort, order);
    //                                     } else if (table == 'todays-appointments') {
    //                                         (side == 'sales') ? TodaysAppointments.RefreshTodaysAppointments(el, sort, order) : TodaysAppointmentsServices.RefreshTodaysAppointments(el, sort, order);
    //                                     }
    //                                 }
    //                             }).fail(function (result) {
    //
    //                                 // show errors on fail
    //                                 var errors = JSON.parse(result.responseText);
    //
    //                                 $('#errors_call').show();
    //                                 $('#errors_call').find('span').remove();
    //                                 $.each(errors, function (e) {
    //                                     $('#errors_call').append('<span style="width:100%;float:left;">' + $(this)[0] + '</span>');
    //                                 });
    //                             }).always(function () {
    //                                 App.loadAjax('unmask');
    //                             });
    //                         }
    //                     },
    //                     // canceling dialog
    //                     Cancel: {
    //                         text: 'Cancel',
    //                         class: 'btn btn-custom cancel-btn pull-left',
    //                         click: function () {
    //                             $(this).dialog("close");
    //                         }
    //                     }
    //                 },
    //                 open: function () {
    //
    //                     // order buttons and inital setup
    //                     $('#errors_call').hide();
    //                     $('.cancel-btn').prepend('<span class="cancel-icon"></span>');
    //                     $('.ui-dialog-buttonset').find('.assign-btn').prepend('<span class="assign-icon"></span>');
    //
    //                     // date picker setup default
    //                     var nextCallField = $('#next_call_cal').parent().find('#next_call');
    //                     var times = new Date(nextCallField.val());
    //
    //                     $("#next_call_cal").datetimepicker({
    //                         dateFormat: "yy-mm-dd",
    //                         timeFormat: "hh:mm tt",
    //                         minDate: times,
    //                         hour: times.getHours(),
    //                         minute: times.getMinutes(),
    //                         second: times.getSeconds(),
    //                         onSelect: function (selectedDate) {
    //                             nextCallField.val(selectedDate);
    //                         }
    //                     });
    //
    //                     // initialize schedule appointment
    //                     App.InitializeMakeAppointment(side);
    //                 },
    //                 close: function () {
    //                     $(this).dialog("close");
    //                     $('#create-call').remove();
    //                 }
    //             });
    //         }
    //     });
    // },

    /* saves new voice blast per customer to db
    * params: el is element clicked, event is current event for that element clicked
    */
    MakeVoiceBlastNew: function (el, side, id) {
        // getting required info fot dialog display
        var form = $("#create_new_single_blast");
        var token = $(form).find("input[name='_token']").val();

        var customers_id = $(el).attr('customers-id');
        $('#customer_id').val(customers_id);
        var user_id = $(el).attr('user-id');
        var title = $(form).find('input[name="title"]').val();
        var audioMessage = $(form).find('select[name="audioMessage"]').val();
        var forwardPhoneNumber = $(form).find('input[name="forwardPhoneNumber"]').val();
        var audioMessageFollowup = $(form).find('select[name="audioMessageFollowup"]').val();


        var data = new FormData();
        data.append('title', title);
        data.append('audioMessage', audioMessage);
        data.append('forwardPhoneNumber', forwardPhoneNumber);
        data.append('audioMessageFollowup', audioMessageFollowup);
        data.append('recipient', customers_id);
        $.ajax({
            type: "POST",
            headers: {'X-CSRF-TOKEN': token},
            url: '/voice_message/single-customer-voice-blast',
            data: $(form).serialize(),
            success: function (result) {
                $('#success_voice').find('span').remove();
                $('#success_voice').hide();
                $('#success_voice').append('<span style="width:100%;float:left;">' + result + '' +
                    '<button type="button" class="close hide-alert" >&times;</button></span>');
                $('#success_voice').show();
                setTimeout(function(){ $('#success_voice').slideUp(); }, 5000);
                $('#title').val("");
                $('input[name=forwardPhoneNumber]').val("");
                $('#audioMessage').val("");
                $('#voice_service').val("");
                $('#audioMessageFollowup').val("");
                if ( $('#recurring').is(":checked")) {
                    $('#recurring').click();
                }
                if ( $('#followupCheckbox').is(":checked")) {
                    $('#followupCheckbox').click();
                }
                var d = new Date();

                var month = d.getMonth()+1;
                var day = d.getDate();

                var output =  ((''+month).length<2 ? '0' : '') + month + '/' +
                    ((''+day).length<2 ? '0' : '') + day  + '/' +
                    d.getFullYear();

                $('input[name="recurring_from"]').val(output);
                $('input[name="recurring_to"]').val(output);
                $('#campaign_id').val("");


            }, error: function (result) {
                var errors = (result.responseJSON.errors);
                $('#errors_voice').show();
                $('#errors_voice').find('span').remove();
                var count = 0;
                if(typeof errors === 'object' && !Array.isArray(errors)) {
                    $.each(errors, function (e) {
                        if (count == 0) {
                            $('#errors_voice').append('<span class="d-block">' + $(this)[0] + '' +
                                '<button type="button" class="close hide-alert" >&times;</button></span>');
                        } else {
                            $('#errors_voice').append('<span class="d-block">' + $(this)[0] + '</span>');
                        }
                        count++;
                    });
                }
                if(Array.isArray(errors)){
                    var err;
                    for( err of errors){
                        $('#errors_voice').append('<span class="d-block">' + err + '</span>');
                        count++;
                    }
                }
            },
        });
    },

    /* saves calls to db
     * params: el is element clicked, event is current event for that element clicked
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    MakeCallNew: function (el, side, id) {
        // getting required info fot dialog display
        let customersId = $(el).attr('customers-id');
        let userId = $(el).attr('user-id');

        App.loadAjax();
        axios.get(`/contacts/create?customers_id=${customersId}&user_id=${userId}`)
            .then(response => {
                App.loadAjax('unmask');
                Swal.fire({
                    title: `Create Call`,
                    showCancelButton: true,
                    html: response.data,
                    width: '25.5rem',
                    confirmButtonText: `Save`,
                    showLoaderOnConfirm: true,
                    didOpen: function () {
                        let nextCalCalendar = $('#next_call_cal');
                        let nextCallField = nextCalCalendar.parent().find('#next_call');

                        nextCalCalendar.flatpickr({
                            inline: true,
                            enableTime: true,
                            onChange: function (selectedDates, dateStr, instance) {
                                nextCallField.val(moment(selectedDates[0]).format('YYYY-MM-DD h:mm a'));
                            }
                        });
                    },
                    preConfirm: () => {
                        let form = $('#create-call').find('form');
                        let data = $(form).serialize();
                        if ($(form).find("#outcome").val() <= 0) {
                            let errorSection = $('#errors_call');
                            errorSection
                                .find('span')
                                .remove();
                            errorSection.append('<span>Outcome not specified!</span>');
                            errorSection.show();

                            return false;
                        }

                        return axios.post('/contacts/store', data)
                            .then(response => {
                                if (window.location.href.indexOf('agent_lists_open') > -1) {
                                    window.location.reload();
                                }

                                if (response.data.error) {
                                    new Noty({
                                        type: 'error',
                                        text: `Error while sending data to Eleads: <br>${response.data.error}`,
                                        timeout: 5000,
                                        progressBar: true
                                    }).show();
                                }

                                // let table = $('#table-section').find('table').attr('id');
                                // $('#comment' + customersId).val(result.comment);
                                // $('#' + customersId).find('.cs-select span:first').text(result.outcome);
                                // $('#' + customersId).find('.next-call-col').val(result.next_call);

                                //update calls list if it was saved
                                let customerData = {
                                    grid: 'contacts',
                                    id: customersId,
                                    page: 1
                                };

                                axios.post('/customers/getAllCustomerInfo', customerData)
                                    .then(response => {
                                        $('#contacts-table').html(response.data);
                                        new Noty({
                                            type: 'success',
                                            text: 'Call successfully added',
                                            timeout: 5000,
                                            progressBar: true
                                        }).show();
                                    })
                                    .catch(err => {
                                        new Noty({
                                            type: 'error',
                                            text: 'Something went wrong when fetching customer info.',
                                            timeout: 5000,
                                            progressBar: true
                                        }).show();
                                    });
                            }).catch(err => {
                                new Noty({
                                    type: 'error',
                                    text: 'Something went wrong when creating call.',
                                    timeout: 5000,
                                    progressBar: true
                                }).show();

                                return false;
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                });
            }).catch(err => {
                new Noty({
                    type: 'error',
                    text: 'Something went wrong while fetching info for call creation.',
                    timeout: 5000,
                    progressBar: true
                }).show();

                return false;
            });
    },

    /**
     * send new mail to customer
     * params: el is element clicked, event is current event for that element clicked
     *
     * @param el
     * @param side
     * @constructor
     */
    SendNewMail: function (el) {
        // getting required info fot dialog display
        let customerId = $(el).closest("#customer-info-dialog").attr('data-customer-id');
        let userId = $(el).closest("#customer-info-dialog").attr('data-user-id');

        App.loadAjax();
        axios.get(`/contacts/createMail?customers_id=${customerId}&user_id=${userId}`)
            .then(response => {
                App.loadAjax('unmask');
                Swal.fire({
                    title: `Create Email`,
                    showCancelButton: true,
                    html: response.data,
                    width: '40rem',
                    confirmButtonText: `Save`,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        // get form data for email
                        let form = $('#create-email').find('form');
                        let data = $(form).serialize();

                        if ($(form).find("#subject").val() <= 0) {
                            let errorSection = $('#errors_email');
                            errorSection
                                .find('span')
                                .remove();
                            errorSection.append('<span>Subject is not specified.</span>');
                            errorSection.show();

                            return false;
                        }

                        if ($(form).find("#message").val() <= 0) {
                            let errorSection = $('#errors_email');
                            errorSection
                                .find('span')
                                .remove();
                            errorSection.append('<span>Message is not specified.</span>');
                            errorSection.show();

                            return false;
                        }

                        return axios.post('/contacts/sendMail', data)
                            .then(response => {
                                new Noty({
                                    type: 'success',
                                    text: 'Email successfully sent.',
                                    timeout: 5000,
                                    progressBar: true
                                }).show();

                                return true;
                            }).catch(err => {
                                // $('#errors_email').show();
                                // $('#errors_email').find('span').remove();
                                // $.each(errors, function (e) {
                                //     $('#errors_email').append('<span style="width:100%;float:left;">' + $(this)[0] + '</span>');
                                // });

                                new Noty({
                                    type: 'error',
                                    text: 'Something went wrong while sending email.',
                                    timeout: 5000,
                                    progressBar: true
                                }).show();

                                return true;
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                });
            }).catch(err => {
                new Noty({
                    type: 'error',
                    text: 'Something went wrong while fetching info for call creation.',
                    timeout: 5000,
                    progressBar: true
                }).show();
        });
    },

    /** Toggle the 1-1 emailing feature **/
    ToggleDirectOptOut: function(el, side) {
        let customers_id = $(el).attr('customers-id');

        axios.post('/contacts/toggleDirectOptOut', {customers_id: customers_id})
            .then(response => {
                let action = 'disabled';
                let button = $("#btn-opt-out-direct");
                let emailButton = $("#btn-new-mail");

                if (response.data.opt_out_direct === 1){
                    button.find(".opt-out-label").html("Enable Email");
                    button.find('i')
                        .removeClass("fa-times-circle")
                        .addClass('fa-check-circle');
                    emailButton.attr('disabled', 'disabled');
                } else {
                    button.find(".opt-out-label").html("Disable Email");
                    button.find('i')
                        .removeClass("fa-check-circle")
                        .addClass('fa-times-circle');
                    emailButton.removeAttr('disabled');
                    action = 'enabled';
                }

                new Noty({
                    type: 'success',
                    text: `1 to 1 Email successfully ${action}`,
                    timeout: 5000,
                    progressBar: true
                }).show();
            })
            .catch(err => {
                new Noty({
                    type: 'error',
                    text: 'Something went wrong while disabling 1 to 1 Email',
                    timeout: 5000,
                    progressBar: true
                }).show();
            });
    },

    loadTemplate: function(el) {
        var $el = $(el);
        var template_id = $el.val();

        $.ajax({
            type: 'get',
            url : '/sms_blast/templates/load/' + template_id,
            success: function(template){
                App.SmsEditor.focus();
                App.SmsEditor.insertText(template.message);
                $('[name=sms_template_id]').val(template.id);
                $('[name=message]').val(App.SmsEditor.value());
            }
        });
    },

    loadEmailTemplate: function(select) {
        var token = $('[name="_token"]').val();
        $("input[name=subject]").val("");
        $("textarea[name=message]").val("");
        var templateId = $(select).val();
        if(templateId.trim() != ""){
            $.ajax({
                type: "POST",
                headers: { 'X-CSRF-TOKEN' : token },
                url: '/email_blast/load_template',
                data: {
                    template_id: templateId
                },
                success:function(result){
                    $("input[name=subject]").val(result.response.subject);
                    $("textarea[name=message]").val(result.response.body);
                    $("input[name=email_template_id]").val(templateId);
                }
            });
        }
    },

    /**
     * @param {Object|Array} el
     * @param {Boolean} service
     * @param {Boolean} plainText
     * @param {String} mode
     */
    SendToCRM: function (el, service, plainText, mode) {
        let ids = [];
        if (el instanceof Array) {
            ids = el;
        } else {
            ids = [$(el).data('id')];
        }
        if (!ids.length) {
            return;
        }

        App.loadAjax();

        let data = {
            method: 'post',
            url: '/contacts/send-to-crm',
            data: {
                customer_ids: ids,
                plaintext: $(el).hasClass('js-plaintext') || plainText,
                service: service || false,
                mode: mode,
            },
            success: function (response) {
                App.showNoty('success', response.message);
            },
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        };

        $.ajax(data).fail(function (error) {
            App.showNoty('error', error.responseJSON.message);
        }).always(function () {
            App.loadAjax('unmask');
        });
    },

    /**
     * @param {Object|Array} el
     * @param {Boolean} service
     */
    SendToVinSolutions: function (el) {
        $(el).prop('disabled', true);
        App.loadAjax();
        let data = {
            method: 'post',
            url: '/contacts/send-to-vin-solutions',
            data: {
                customer_id: $(el).data('id')
            },
            success: function (response) {
                App.showNoty(response.status, response.message);
                if (response.status === 'success' && $(el).text().trim() === 'Send to VinSolution') {
                    $(el).text('Update VinSolution');
                    $('.vin-solutions-id-row')
                        .removeClass('d-none')
                        .find('.vin-solutions-id-value').text(response.id);
                }
            },
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        };

        $.ajax(data).fail(function (error) {
            console.error(error)
        }).always(function () {
            $(el).prop('disabled', false);
            App.loadAjax('unmask');
        });
    },

    /**
     * @param {Object|Array} el
     * @param {Boolean} service
     */
    SendToElead: function (el) {
        App.loadAjax();
        let data = {
            method: 'post',
            url: '/eleads/send-to-eleads',
            data: {
                customer_id: $(el).data('id')
            },
            success: function (response) {
                App.showNoty(response.status, response.message);
                if (response.id) {
                    $(el).text('Update eLeads');
                    $('#eleads-table-row td:last span').text(response.id);
                    $('#eleads-table-row').show();
                }
            },
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        };

        $.ajax(data).fail(function (error) {
            console.error(error)
        }).always(function () {
            App.loadAjax('unmask');
        });
    },

    /**
     * @param {Object} el
     */
    SwitchReportVisibility: function (el) {
        let $el = $(el);
        App.loadAjax();

        $.ajax({
            method: 'post',
            url: '/customers/toggle-report',
            data: {
                customer_id: $el.data('id')
            },
            success: function (response) {
                if (response == 1) {
                    $el
                        .removeClass('btn-primary-dark-blue')
                        .addClass('btn-danger')
                        .find('span')
                        .text('Exclude from Attr. Report');
                } else {
                    $el
                        .removeClass('btn-danger')
                        .addClass('btn-primary-dark-blue')
                        .find('span')
                        .text('Include in Attr. Report');
                }
            },
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        }).fail(function (error) {
            console.error(error)
        }).always(function () {
            App.loadAjax('unmask');
        });
    },

    /**
     * Show dialog for sending 1-1 direct SMS to customer
     *
     * @param Object el button clicked
     * @param Current system side
     */
    SendCustomerSms: function(el) {
        let customers_id = $(el).attr('data-id');
        App.loadAjax();

        axios.get(`/contacts/create_sms?customer_id=${customers_id}`)
            .then(response => {
                App.loadAjax('unmask');

                Swal.fire({
                    title: `Create SMS`,
                    showCancelButton: true,
                    html: response.data,
                    width: '40rem',
                    confirmButtonText: `Save`,
                    showLoaderOnConfirm: true,
                    didOpen: function () {
                        App.SmsEditor = Emojion.createEditor(document.getElementById('smsEditor'));
                    },
                    preConfirm: () => {
                        if (App.SmsEditor) {
                            $('#smsEditor').val(App.SmsEditor.value());
                        }
                        // get form data for email
                        let form = $('#create-sms').find('form');
                        let data = $(form).serialize();
                        let errorSection = $('#errors_sms');

                        if (App.SmsEditor.value() == '') {
                            errorSection.show();
                            errorSection.find('span').remove();
                            errorSection.append('<span>Message is not specified.</span>');
                            return false;
                        }

                        return axios.post('/contacts/send_sms', data)
                            .then(response => {
                                new Noty({
                                    type: 'success',
                                    text: 'SMS successfully sent.',
                                    timeout: 5000,
                                    progressBar: true
                                }).show();

                                return true;
                            }).catch(err => {
                                if (err.response.data.errors !== undefined) {
                                    for (const [key, value] of Object.entries(err.response.data.errors)) {
                                        App.showNoty('error', value);
                                    }
                                } else {
                                    App.showNoty('error', 'Something went wrong while sending SMS.')
                                }

                                return false;
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                });
            }).catch(err => {
                new Noty({
                    type: 'error',
                    text: 'Something went wrong while fetching info for call creation.',
                    timeout: 5000,
                    progressBar: true
                }).show();
        });
    },

    /**
     * Toggle the 1-1 SMS feature
     *
     * @param Object el The HTML element
     */
    ToggleDirectOptOutSms: function(el) {
        let customer_id = $(el).data('id');

        axios.post('/contacts/toggle_direct_opt_out_sms', {client_id: customer_id})
            .then(response => {
                let toggleButton = $('#btn-opt-out-direct-sms');
                let sendButton = $('#btn-new-sms');

                if (response.data.opt_out_direct_sms === 1) {
                    toggleButton.find(".opt-out-label").html("Enable 1 to 1 SMS");
                    toggleButton.find("i")
                        .removeClass("fa-times-circle")
                        .addClass('fa-check-circle');
                    sendButton.prop('disabled', true);
                } else {
                    toggleButton.find(".opt-out-label").html("Disable 1 to 1 SMS");
                    toggleButton.find(".opt-out-icon")
                        .removeClass("fa-check-circle")
                        .addClass('fa-times-circle');
                    sendButton.prop('disabled', false);
                }

                new Noty({
                    type: 'success',
                    text: '1 to 1 SMS successfully disabled',
                    timeout: 5000,
                    progressBar: true
                }).show();
            })
            .catch(err => {
                new Noty({
                    type: 'error',
                    text: 'Something went wrong while disabling 1 to 1 SMS',
                    timeout: 5000,
                    progressBar: true
                }).show();
            });
    },

    /* initilization of appointment feature
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    InitializeMakeAppointment: function (side) {
        $('#create-call .cs-select li, table .cs-select li').click(function () {
            if ($(this).attr('data-original-index') == '4') {
                App.MakeAppointmentNew(this, $('#call_box'), side);
            }
        });
    },

    /* choosing appointment date from new dialog and remembering before save
     * params: el is element clicked, callBox is from where is called
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    /*MakeAppointment: function (element, callBox, side) {
     App.loadAjax();

     // check if the func is called from grid or box
     callBox = typeof callBox !== 'undefined' ? callBox : false;

     if (callBox) {

     // from box get inputs there and values
     var row = $(element).parents('#create-call');

     var data = {
     client_id: row.find('input[name=client_id]').val(),
     user_id: row.find('input[name=user_id]').val()
     };
     } else {

     // from grid get same values
     var row = $(element).parents('tr');

     var data = {
     client_id: row.attr('client-id'),
     user_id: row.attr('user-id')
     };
     }

     // procceed with ajax call to schedule appointment
     $.ajax({
     type: "GET",
     url: side == 'sales' ? '/calls/scheduleAppointment' : '/serviceCalls/scheduleAppointment',
     data: data,
     dataType: 'html',
     success: function(result) {
     App.loadAjax('unmask');

     // initialize new dialog for appointments
     $('body').append(result);

     $('#schedule-appointment').dialog({
     width: 400,
     modal: true,
     position: {my: 'top', at: 'top+150'},
     buttons: {
     Assign: {
     text: 'Schedule Appointment',
     class: 'btn btn-custom assign-btn',
     click: function() {
     App.loadAjax();

     // add hidden input with this date for later save
     var prevSchedule = row.find('.appointment_schedule');
     var newSchedule = $('#schedule-appointment').find('#appointment_date').val();

     // if exists update or append new
     if (prevSchedule[0]) {
     prevSchedule.val(newSchedule);
     } else {
     var input = '<input type="hidden"'
     + ' name="appointment_schedule"'
     + ' value="'+ newSchedule
     + '">';
     console.log(row);
     callBox ? row.find('form > fieldset').append(input) : row.append(input);
     }

     $(this).dialog( "close" );
     $('#schedule-appointment').remove();

     App.loadAjax('unmask');
     }
     },

     Cancel: {
     text: 'Cancel',
     class: 'btn btn-custom cancel-btn',
     click: function() {
     $(this).dialog( "close" );
     $('#schedule-appointment').remove();
     }
     }
     },
     open: function() {

     // buttons order
     $('div[aria-describedby=schedule-appointment] .cancel-btn').prepend('<span class="cancel-icon"></span>');
     $('div[aria-describedby=schedule-appointment] .ui-dialog-buttonset').find('.assign-btn').prepend('<span class="assign-icon"></span>');

     // initialize appointment date prev
     var appointmentDateField = $('#schedule-appointment').find('#appointment_date');

     var prevSchedule = row.find('input[name=appointment_schedule]');

     if (prevSchedule[0]) {
     var times = new Date(prevSchedule.val());
     } else {
     var times = new Date(appointmentDateField.val());
     }

     $( "#appointment_date_box" ).datetimepicker({
     dateFormat: "yy-mm-dd",
     timeFormat: "hh:mm tt",
     minDate: times,
     hour: times.getHours(),
     minute: times.getMinutes(),
     second: times.getSeconds(),
     onSelect: function(selectedDate) {
     appointmentDateField.val(selectedDate);
     }
     });
     },
     close: function() {
     $(this).dialog( "close" );
     $('#schedule-appointment').remove();
     }
     });
     }
     }).always(function(){
     App.loadAjax('unmask');
     });

     App.loadAjax('unmask');
     },*/
    /* choosing appointment date from new dialog and remembering before save
     * params: el is element clicked, callBox is from where is called
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    MakeAppointmentNew: function (element, callBox, side) {
        App.loadAjax();

        // check if the func is called from grid or box
        callBox = typeof callBox !== 'undefined' ? callBox : false;

        if (callBox) {

            // from box get inputs there and values
            var row = $(element).parents('#create-call');

            var data = {
                client_id: row.find('input[name=client_id]').val(),
                user_id: row.find('input[name=user_id]').val()
            };
        } else {

            // from grid get same values
            var row = $(element).parents('tr');

            var data = {
                client_id: row.attr('customers-id'),
                user_id: row.attr('user-id')
            };
        }
        $('#errors_call').remove(); // remove error message

        // procceed with ajax call to schedule appointment
        $.ajax({
            type: "GET",
            url: '/contacts/scheduleAppointment',
            data: data,
            dataType: 'html',
            success: function (result) {
                App.loadAjax('unmask');

                // initialize new dialog for appointments
                $('body').append(result);

                $('#schedule-appointment').dialog({
                    dialogClass: 'dialog-position-3',
                    width: 400,
                    modal: true,
                    position: {my: 'top', at: 'top+150'},
                    buttons: {
                        Assign: {
                            text: 'Schedule Appointment',
                            class: 'btn btn-custom assign-btn pull-right',
                            click: function () {
                                App.loadAjax();
                                //var newSchedule = $('#schedule-appointment').find('#appointment_date').val();


                                // add hidden input with this date for later save
                                var prevSchedule = row.find('.appointment_schedule');
                                var newSchedule = $('#schedule-appointment').find('#appointment_date').val();
                                $("#appointment_date").val(newSchedule);

                                var appointmentComment = $('#appointment_comment').val();

                                // if exists update or append new
                                if (prevSchedule[0]) {
                                    prevSchedule.val(newSchedule);
                                } else {
                                    var input = '<input type="hidden"'
                                        + ' name="appointment_schedule"'
                                        + ' value="' + newSchedule
                                        + '">';

                                    var commentInput = '<input type="hidden"'
                                        + ' name="appointment_comment"'
                                        + ' value="' + appointmentComment
                                        + '">';

                                    console.log(row);
                                    row.find("input[name*='comment']").val(appointmentComment);
                                    callBox ? row.find('form > fieldset').append(input) : row.append(input);
                                    callBox ? row.find('form > fieldset').append(commentInput) : row.append(commentInput);
                                }

                                $(this).dialog("close");
                                $('#schedule-appointment').remove();

                                App.loadAjax('unmask');
                            }
                        },

                        Cancel: {
                            text: 'Cancel',
                            class: 'btn btn-custom cancel-btn pull-left',
                            click: function () {
                                $(this).dialog("close");
                                $('#schedule-appointment').remove();
                            }
                        }
                    },
                    open: function () {

                        // buttons order
                        $('div[aria-describedby=schedule-appointment] .cancel-btn').prepend('<span class="cancel-icon"></span>');
                        $('div[aria-describedby=schedule-appointment] .ui-dialog-buttonset').find('.assign-btn').prepend('<span class="assign-icon"></span>');

                        // initialize appointment date prev
                        var appointmentDateField = $('#schedule-appointment').find('#appointment_date');

                        var prevSchedule = row.find('.appointment_schedule');

                        if (prevSchedule[0]) {
                            var times = new Date(prevSchedule.val());
                        } else {
                            var times = new Date(appointmentDateField.val());
                        }

                        $("#appointment_date_box").datetimepicker({
                            dateFormat: "yy-mm-dd",
                            timeFormat: "hh:mm tt",
                            minDate: times,
                            hour: times.getHours(),
                            minute: times.getMinutes(),
                            second: times.getSeconds(),
                            onSelect: function (selectedDate) {
                                appointmentDateField.val(selectedDate);
                            }
                        });
                    },
                    close: function () {
                        $(this).dialog("close");
                        $('#schedule-appointment').remove();
                    }
                });
            }
        }).always(function () {
            App.loadAjax('unmask');
        });

        App.loadAjax('unmask');
    },
    /* getting variable from url
     * params: variable - variable name we want to get
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    GetQueryVariable: function (variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (false);
    },

    /* on single click view call dialog services info for this client
     * type param is for refreshing table without reloading dialog
     * el is element clicked
     * author: marko dzunic, marko.d@scopicsoftware.com
     */
    ViewCallsServiceData: function (el, type) {

        // getting ids from tr element
        var token = $('[name="_token"]').val();
        var client_id = $(el).attr('client-id');
        var date_birth = $(el).attr('date-birth');
        var first_name = $(el).attr('first-name');
        var last_name = $(el).attr('last-name');
        var full_name = $(el).attr('full-name');
        var vin = $(el).attr('vin');
        var customer_number = $(el).attr('customer-number');

        App.loadAjax();

        $.ajax({
            type: "POST",
            headers: {'X-CSRF-TOKEN': token},
            url: '/calls/service_dialog_data',
            dataType: 'html',
            data: {
                client_id: client_id,
                type: type,
                date_birth: date_birth,
                first_name: first_name,
                last_name: last_name,
                full_name: full_name,
                vin: vin,
                customer_number: customer_number
            },
            success: function (result) {
                App.loadAjax('unmask');

                // calling dialog for calls
                $('body').append(result);
                $('#service-dialog-call').dialog({
                    // dialogClass: 'dialog-position',
                    width: 900,
                    modal: true,
                    buttons: {
                        Save: {
                            text: 'OK',
                            class: 'btn btn-custom assign-btn pull-right',
                            click: function () {
                                // making call dialog init
                                $(this).dialog("close");
                                $('#service-dialog-call').remove();
                            }
                        }
                    },
                    open: function () {
                        // order buttons in dialog
                        $('#service-dialog-call .cancel-btn').prepend('<span class="cancel-icon"></span>');
                        $('#service-dialog-call .ui-dialog-buttonset').find('.assign-btn').prepend('<span class="assign-icon"></span>');
                    },
                    close: function () {
                        $(this).dialog("close");
                        $('#service-dialog-call').remove();
                    }
                });
            }
        });
    },

    /**Change read-only status of input field**/
    EnableInput: function (el) {
        $(el).removeAttr('readonly');
    },

    /*
  	* Add a new note entry
  	*/
    AddNewNote: function(customer_id, eleadsEnabled) {
        let eleadsCheckbox = !eleadsEnabled ? '' :
        `<div class="custom-control custom-checkbox mt-4">
            <input id="note_to_eleads" type="checkbox" class="custom-control-input">
            <label for="note_to_eleads" class="custom-control-label ml-2 float-left">
                <span>Send to eLeads</span>
            </label>
        </div>`;
        Swal.fire({
            title: `Add New Note`,
            showCancelButton: true,
            html: `<div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <textarea id="note-entry"
                                  class="form-control mb-2 form-control-sm"
                                  rows="6"></textarea>
                        <div id="note-msg"></div>
                        ${eleadsCheckbox}
                    </div>
                </div>
            </div>`,
            confirmButtonText: `Save`,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                let note = $("#note-entry").val();
                let data = {customer_id, note, send_to_eleads: $('#note_to_eleads').is(':checked')};

                if ($.trim(note) === "") {
                    $("#note-msg")
                        .html('Please add note before saving.')
                        .addClass("alert alert-danger");

                    return false;
                }

                return axios.post('/customer/add_new_note', data)
                    .then(response => {
                        let customerData = {
                            grid: 'notes',
                            id: customer_id,
                            page: 1
                        };
                        axios.post('/customers/getAllCustomerInfo', customerData)
                            .then(response => {
                                $('#notes-table').html(response.data);
                                $('#notes-table #collapseNotes').collapse('show');

                                new Noty({
                                    type: 'success',
                                    text: 'Note successfully added',
                                    timeout: 5000,
                                    progressBar: true
                                }).show();
                            }).catch(error => {
                                new Noty({
                                    type: 'error',
                                    text: 'Something went wrong while fetching notes.',
                                    timeout: 5000,
                                    progressBar: true
                                }).show();
                        })

                        return true;
                    }).catch(error => {
                        console.log(error);

                        return false;
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        });
    },

    /*
    * Edit a new note entry
    */
    EditNote: function(note_id, customer_id, eleadsEnabled) {
        App.loadAjax();
        let eleadsCheckbox = !eleadsEnabled ? '' :
            `<div class="custom-control custom-checkbox mt-4">
            <input id="note_to_eleads" type="checkbox" class="custom-control-input">
            <label for="note_to_eleads" class="custom-control-label ml-2 float-left">
                <span>Send to eLeads</span>
            </label>
        </div>`;

        axios.post('/customer/getNote', {id: note_id})
            .then(response => {
                App.loadAjax('unmask');
                let note = response.data.note;
                Swal.fire({
                    title: `Edit Note`,
                    showCancelButton: true,
                    html: `<div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <textarea id="note-entry"
                                          class="form-control mb-2 form-control-sm"
                                          rows="6">${note}</textarea>
                                <div id="note-msg"></div>
                                ${eleadsCheckbox}
                            </div>
                        </div>
                    </div>`,
                    confirmButtonText: `Save`,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        let note = $("#note-entry").val();
                        let data = {
                            note_id: note_id,
                            note: note,
                            send_to_eleads: $('#note_to_eleads').is(':checked')
                        };

                        if ($.trim(note) === "") {
                            $("#note-msg")
                                .html('Please add note before saving.')
                                .addClass("alert alert-danger");

                            return false;
                        }

                        return axios.post('/customer/edit_note', data)
                            .then(response => {
                                let customerData = {
                                    grid: 'notes',
                                    id: customer_id,
                                    page: 1
                                };
                                return axios.post('/customers/getAllCustomerInfo', customerData)
                                    .then(response => {
                                        $('#notes-table').html(response.data);
                                        $('#notes-table #collapseNotes').collapse('show');

                                        new Noty({
                                            type: 'success',
                                            text: 'Note successfully edited',
                                            timeout: 5000,
                                            progressBar: true
                                        }).show();

                                        return true;
                                    }).catch(error => {
                                        new Noty({
                                            type: 'error',
                                            text: 'Something went wrong while fetching notes.',
                                            timeout: 5000,
                                            progressBar: true
                                        }).show();

                                        return false;
                                })
                            }).catch(error => {
                                console.log(error);

                                return false;
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                });
        }).catch(error => {
            console.log(error);
            new Noty({
                type: 'error',
                text: 'Something went wrong while fetching note.',
                timeout: 5000,
                progressBar: true
            }).show();
        });
    },

    /*
    * Delete a new note entry
    */
    DeleteNote: function(note_id, customer_id) {
        Swal.fire({
            title: `Delete Note`,
            html: `<div class="text-left">Are you sure you wish to delete this note?</div>`,
            showCancelButton: true,
            confirmButtonText: `Yes`,
            cancelButtonText: `No`,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return axios.post('/customer/delete_note', {id: note_id})
                    .then(response => {
                        let customerData = {
                            grid: 'notes',
                            id: customer_id,
                            page: 1
                        };
                        return axios.post('/customers/getAllCustomerInfo', customerData)
                            .then(response => {
                                $('#notes-table').html(response.data);
                                $('#notes-table #collapseNotes').collapse('show');

                                new Noty({
                                    type: 'success',
                                    text: 'Note successfully deleted.',
                                    timeout: 5000,
                                    progressBar: true
                                }).show();

                                return true;
                            }).catch(error => {
                                new Noty({
                                    type: 'error',
                                    text: 'Something went wrong while fetching notes.',
                                    timeout: 5000,
                                    progressBar: true
                                }).show();

                                return false;
                        })
                    }).catch(error => {
                        console.log(error);

                        return false;
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        });
    },

    ExpandVehicleDetails : function(evt, el, id, customers_id, vin) {
        // if the column with the checkbox under 'Owned Vehicle' is clicked,
        // we don't want to handle event through this method
        var cell = $(evt.target).get(0); // This is the TD you clicked
        if(cell.nodeName != 'TD')
            cell = $(cell).closest('td').get(0);

        if($(cell).hasClass('select-col')){
            return false;
        }

        var token = $('[name="_token"]').val();

        $(el).css({
            'font-style': 'italic',
            'font-weight': 'bold'
        });

        if ($('#vehicle-details-'+id).length == 0) {
            App.loadAjax();
            $.ajax({
                type: "POST",
                headers: { 'X-CSRF-TOKEN' : token },
                url: '/customers/getVehicleDetails',
                data: {
                    id: id,
                    vin: vin,
                    customers_id: customers_id
                },
                success: function(result){
                    $(el).next('tr').find('.accordian-body div').html(result);
                    // $('#vehicle-details-'+id).html(result);
                    // $('.component_pop').popover();
                    App.loadAjax('unmask');
                    App.InitVehicleEditable();
                }
            });
        } else {
            $('#vehicle-details-'+id).remove();
            $(el).css({
                'font-style': 'normal',
                'font-weight': 'normal'
            });
        }
    },

    PrintCustomerInfo: function (customers_id){
        var token = $('[name="_token"]').val();
        var link = window.location.protocol + '//' + window.location.host + '/customers/printCustomerInfo';

        var printWin = window.open('', '', 'width=' + window.innerWidth + ',height=' + window.innerHeight);

        $.ajax({
            type: "POST",
            headers: {'X-CSRF-TOKEN': token},
            data: {id: customers_id},
            url: link,
            success: function (response) {
                App.loadAjax('unmask');

                printWin.document.open();
                printWin.document.write(response);
                printWin.document.close();

                // Wait for the page to load, and after that we print and close the window
                printWin.focus();
                printWin.print();
                printWin.close();
            }
        });
    },

    InitEditable: function() {
        // init editable for phone numbers
        var editableFields = [
            {
                field: '#editable_home_phone',
                name: 'home_phone',
                title: 'Update home phone',
                trigger: '#home_phone_edit',
                url: '/customers/update_contact'
            },
            {
                field: '#editable_cell_phone',
                name: 'cell_phone',
                title: 'Update cell phone',
                trigger: '#cell_phone_edit',
                url: '/customers/update_contact'
            },
            {
                field: '#editable_work_phone',
                name: 'work_phone',
                title: 'Update work phone',
                trigger: '#work_phone_edit',
                url: '/customers/update_contact'
            }
        ];

        // editable ccutomer contacts
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.each(editableFields, function(key, item) {
            $(item.field).editable({
                type: 'text',
                send: 'always',
                name: item.name,
                ajaxOptions:{
                    type:'post'
                } ,
                params: function(params) {
                    //originally params contain pk, name and value
                    params.a = 1;
                    return params;
                },
                success: function (response, newVal) {
                    var current_pk = $(this).data('pk');
                    if($("table tr[customers-id*='"+current_pk+"']")){
                        if($(this).attr('id').replace("editable_", "") == 'home_phone'){
                            $("table tr[customers-id*='"+current_pk+"'] td:nth-child(4)").html(newVal);
                        }
                        if($(this).attr('id').replace("editable_", "") == 'cell_phone'){
                            $("table tr[customers-id*='"+current_pk+"'] td:nth-child(5)").html(newVal);
                        }
                    }

                },
                url: item.url,
                title: item.title,
                toggle:'manual',
                tpl: '<input type="text" class="phone-mask" maxlength="14"/>',
                validate: function(value) {
                    var pattern = new RegExp(/\+\d \(\d\d\d\) \d\d\d \d\d\d\d?/);
                    if ($.trim(value) == '') {
                        return 'Phone number is required';
                    }

                    if (!pattern.test(value)) {
                        return "Phone number does not meet format\n+x (xxx) xxx xxxx.";
                    }
                }
            });
            $(item.trigger).click(function(e){
                e.stopPropagation();
                $(item.field).editable('show');
            });
            $(item.field).on('shown', function(e, editable) {
                setTimeout(function(){
                    App.setCaretToPos($('.phone-mask')[0], 1);
                }, 50);
            });
        });



        $(document).on("focus", ".phone-mask", function () {
            $(this).mask('+0 (000) 000 0000');
        });

        const emailEditableFields = [
            {
                field: '#editable_email_1',
                name: 'email_1',
                title: 'Update email',
                trigger: '#email_1_edit',
                url: '/customers/update_contact'
            },
            {
                field: '#editable_email_2',
                name: 'email_2',
                title: 'Update email',
                trigger: '#email_2_edit',
                url: '/customers/update_contact'
            },
            {
                field: '#editable_email_3',
                name: 'email_3',
                title: 'Update email',
                trigger: '#email_3_edit',
                url: '/customers/update_contact'
            }
        ];

        for (const field in emailEditableFields) {
            let emailEditableField = emailEditableFields[field];
            if (!emailEditableField) continue;

            $(emailEditableField.field).editable({
                type: 'text',
                send: 'always',
                name: emailEditableField.name,
                ajaxOptions:{
                    type:'post'
                },
                validate: function(value) {
                    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    if($.trim(value) != '' && !regex.test(value)) {
                        return 'Please provide a valid email';
                    }
                },
                params: function(params) {
                    //originally params contain pk, name and value
                    params.a = 1;
                    return params;
                },
                success: function (response, newVal) {
                    var current_pk = $(this).data('pk');
                    if($("table tr[customers-id*='"+current_pk+"']")){
                        if($(this).attr('id').replace("editable_", "") == 'email_1'){
                            $("table tr[customers-id*='"+current_pk+"'] td:nth-child(9)").html(newVal);
                        }
                    }
                },
                url: emailEditableField.url,
                title: emailEditableField.title,
                toggle:'manual',
                tpl: '<input type="text" class="email-mask" />'
            });

            $(emailEditableField.trigger).click(function(e){
                e.stopPropagation();
                $(emailEditableField.field).editable('show');
            });
        }

        $(document).on("focus", ".email-mask", function () {
            $(this).mask("A", {
                translation: {
                    "A": { pattern: /[\w@\-.+]/, recursive: true }
                }
            });
        });

        var urlEditableField = {
            field: '#editable_url',
            name: 'url',
            title: 'Update url',
            trigger: '#url_edit',
            url: '/customers/update_contact'
        };

        $(urlEditableField.field).editable({
            type: 'text',
            send: 'always',
            name: urlEditableField.name,
            ajaxOptions:{
                type:'post'
            },
            url: urlEditableField.url,
            title: urlEditableField.title,
            toggle:'manual',
            tpl: '<input type="text" />'
        });

        $(urlEditableField.trigger).click(function(e){
            e.stopPropagation();
            $(urlEditableField.field).editable('show');
        });

        // init editable for city
        var cityEditableField = {
            field: '#editable_city',
            name: 'city',
            title: 'Update city',
            trigger: '#city_edit',
            url: '/customers/update_contact'
        };

        $(cityEditableField.field).editable({
            type: 'text',
            send: 'always',
            name: cityEditableField.name,
            ajaxOptions:{
                type:'post'
            },
            url: cityEditableField.url,
            title: cityEditableField.title,
            toggle:'manual',
            tpl: '<input type="text" />'
        });

        $(cityEditableField.trigger).click(function(e){
            e.stopPropagation();
            $(cityEditableField.field).editable('show');
        });

        // init editable for state
        var stateEditableField = {
            field: '#editable_state',
            name: 'state',
            title: 'Update state',
            trigger: '#state_edit',
            url: '/customers/update_contact'
        };

        $(stateEditableField.field).editable({
            type: 'text',
            send: 'always',
            name: stateEditableField.name,
            ajaxOptions:{
                type:'post'
            },
            url: stateEditableField.url,
            title: stateEditableField.title,
            toggle:'manual',
            tpl: '<input type="text" />'
        });

        $(stateEditableField.trigger).click(function(e){
            e.stopPropagation();
            $(stateEditableField.field).editable('show');
        });

        // init editable for zip
        var zipEditableField = {
            field: '#editable_zip',
            name: 'zip',
            title: 'Update zip',
            trigger: '#zip_edit',
            url: '/customers/update_contact'
        };

        $(zipEditableField.field).editable({
            type: 'text',
            send: 'always',
            name: zipEditableField.name,
            ajaxOptions:{
                type:'post'
            },
            url: zipEditableField.url,
            title: zipEditableField.title,
            toggle:'manual',
            tpl: '<input type="text" />'
        });

        $(zipEditableField.trigger).click(function(e){
            e.stopPropagation();
            $(zipEditableField.field).editable('show');
        });

        // init editable for address line 1
        var addressLine1EditableField = {
            field: '#editable_address_line_1',
            name: 'address_line_1',
            title: 'Update address_line_1',
            trigger: '#address_line_1_edit',
            url: '/customers/update_contact'
        };

        $(addressLine1EditableField.field).editable({
            type: 'text',
            send: 'always',
            name: addressLine1EditableField.name,
            ajaxOptions:{
                type:'post'
            },
            url: addressLine1EditableField.url,
            title: addressLine1EditableField.title,
            toggle:'manual',
            tpl: '<input type="text" />'
        });

        $(addressLine1EditableField.trigger).click(function(e){
            e.stopPropagation();
            $(addressLine1EditableField.field).editable('show');
        });

        // init editable for address line 2
        var addressLine2EditableField = {
            field: '#editable_address_line_2',
            name: 'address_line_2',
            title: 'Update address line 2',
            trigger: '#address_line_2_edit',
            url: '/customers/update_contact'
        };

        $(addressLine2EditableField.field).editable({
            type: 'text',
            send: 'always',
            name: addressLine2EditableField.name,
            ajaxOptions:{
                type:'post'
            },
            url: addressLine2EditableField.url,
            title: addressLine2EditableField.title,
            toggle:'manual',
            tpl: '<input type="text" />'
        });

        $(addressLine2EditableField.trigger).click(function(e){
            e.stopPropagation();
            $(addressLine2EditableField.field).editable('show');
        });

        // init editable for entity
        var entityEditableField = {
            field: '#editable_entity',
            name: 'entity',
            title: 'Update entity',
            trigger: '#entity_edit',
            url: '/customers/update_contact'
        };

        $(entityEditableField.field).editable({
            type: 'select',
            send: 'always',
            name: entityEditableField.name,
            ajaxOptions:{
                type:'post'
            },
            validate: function(value) {
                if($.trim(value) == '' ) {
                    return 'Please select an entity type';
                }
            },
            params: function(params) {
                //originally params contain pk, name and value
                params.a = 1;
                return params;
            },
            source: [
                {value: 'Individual', text: 'Individual'},
                {value: 'Business', text: 'Business'}
            ],
            url: entityEditableField.url,
            title: entityEditableField.title,
            toggle:'manual'
        });

        $(entityEditableField.trigger).click(function(e){
            e.stopPropagation();
            $(entityEditableField.field).editable('show');
        });
        // unsubscribe_edit
        var unsubscribeEditableField = {
            field: '#editable_unsubscribe',
            name: 'unsubscribe',
            title: 'Update unsubscribe',
            trigger: '#unsubscribe_edit',
            url: '/customers/update_contact'
        };

        $(unsubscribeEditableField.field).editable({
            send: 'always',
            name: unsubscribeEditableField.name,
            ajaxOptions:{
                type:'post'
            },
            url: unsubscribeEditableField.url,
            title: unsubscribeEditableField.title,
            toggle:'manual',
            success: function (response, newVal) {
                setTimeout(function(){
                    $(unsubscribeEditableField.field).html(newVal == '1' ? 'Unsubscribed' : 'Subscribed');
                    $('#btn-new-mail').prop('disabled', newVal == '1');
                }, 50);
            },
        });

        $(unsubscribeEditableField.trigger).click(function(e){
            e.stopPropagation();
            $(unsubscribeEditableField.field).editable('show');
        });
        // unsubscribe_edit_sms
        var unsubscribeEditableSmsField = {
            field: '#editable_unsubscribe_sms',
            name: 'unsubscribe_sms',
            title: 'Update unsubscribe SMS',
            trigger: '#unsubscribe_sms_edit',
            url: '/customers/update_contact'
        };

        $(unsubscribeEditableSmsField.field).editable({
            send: 'always',
            name: unsubscribeEditableSmsField.name,
            ajaxOptions:{
                type:'post'
            },
            url: unsubscribeEditableSmsField.url,
            title: unsubscribeEditableSmsField.title,
            toggle:'manual',
            success: function (response, newVal) {
                setTimeout(function(){
                    $(unsubscribeEditableSmsField.field).html(newVal == '1' ? 'Unsubscribed' : 'Subscribed');
                    $('#btn-new-sms').prop('disabled', newVal == '1');
                }, 50);
            },
        });

        $(unsubscribeEditableSmsField.trigger).click(function(e){
            e.stopPropagation();
            $(unsubscribeEditableSmsField.field).editable('show');
        });

        // unsubscribe_edit_sms
        var unsubscribeEditableDirectMailField = {
            field: '#editable_unsubscribe_mail',
            name: 'unsubscribe_mail',
            title: 'Update unsubscribe Direct Mail',
            trigger: '#unsubscribe_mail_edit',
            url: '/customers/update_contact'
        };

        $(unsubscribeEditableDirectMailField.field).editable({
            send: 'always',
            name: unsubscribeEditableDirectMailField.name,
            ajaxOptions:{
                type:'post'
            },
            url: unsubscribeEditableDirectMailField.url,
            title: unsubscribeEditableDirectMailField.title,
            toggle:'manual',
            success: function (response, newVal) {
                setTimeout(function(){
                    $(unsubscribeEditableDirectMailField.field).html(newVal == '1' ? 'Unsubscribed' : 'Subscribed');
                }, 50);
            },
        });

        $(unsubscribeEditableDirectMailField.trigger).click(function(e){
            e.stopPropagation();
            $(unsubscribeEditableDirectMailField.field).editable('show');
        });
    },

    InitVehicleEditable: function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        // init editable for nada_trade_in
        var nadaTradeInEditableField = {
            field: '#editable_nada_trade_in',
            name: 'nada_trade_in',
            title: 'Update J.D.P. Trade In',
            trigger: '#nada_trade_in_edit',
        };

        $(nadaTradeInEditableField.field).editable({
            type: 'text',
            send: 'always',
            name: nadaTradeInEditableField.name,
            ajaxOptions:{
                type:'post'
            },
            title: nadaTradeInEditableField.title,
            toggle:'manual',
            validate: function(value) {
                var regex = /^\d*(\.\d{0,2})?$/;
                if($.trim(value) != '' && !regex.test(value)) {
                    return 'Please provide a valid number';
                }
            },
            success: function (response, newVal) {
                var current_pk = $(this).data('pk');
                var currencyVal = parseInt(newVal).toFixed(2);
                if($("table tr[vehicle-id*='"+current_pk+"']")){
                    $("table tr[vehicle-id*='"+current_pk+"'] td.nada-trade-in-cell").html(currencyVal);
                }
                setTimeout(function(){
                    $("#editable_nada_trade_in").html(currencyVal);
                }, 50);
            },
        });


        $(nadaTradeInEditableField.trigger).click(function(e){
            e.stopPropagation();
            $(nadaTradeInEditableField.field).editable('show');
        });
    },

    setSelectionRange: function(input, selectionStart, selectionEnd) {
        if (input.setSelectionRange) {
            input.focus();
            input.setSelectionRange(selectionStart, selectionEnd);
        }
        else if (input.createTextRange) {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', selectionEnd);
            range.moveStart('character', selectionStart);
            range.select();
        }
    },

    setCaretToPos: function(input, pos) {
        App.setSelectionRange(input, pos, pos);
    },

    /**
     * Utility function to get page URL  params
     *
     * @return array Array of objects holding key-value properties of params
     */
    getPageParams: function() {
        var query_string = document.location.search.substring(1);
        var components = query_string.split('&');
        var params = [];

        for (var i = 0;i < components.length; i++) {
            var key_value = components[i].split("=");
            var key = key_value[0];
            var value = (key_value.length > 1) ? key_value[1] : "";

            params.push({
                key: key,
                value: value
            });
        }

        return params;
    },

    printAppraisal: function() {

        var $error_span =  $('#appraise-error');
        var token = $('#token').val();
        var vin = $('#appraisal-vehicle').val();
        $error_span.css('display', 'none');
        $error_span.html('');
        if (vin == 0) {
            console.log('vin 0');
            $error_span.html('Please Select Vin');
            $error_span.css('display', 'block');
            return false;
        }
        var printWin = window.open('', '', 'width=' + window.innerWidth + ',height=' + window.innerHeight);
        var data = {'vin': vin};
        var link = window.location.protocol + '//' + window.location.host + '/customers/printAppraisalInfo';
        $.ajax({
            type: "POST",
            headers: {'X-XSRF-TOKEN': token},
            data: data,
            url: link,
            success: function (response) {
                App.loadAjax('unmask');

                printWin.document.open();
                printWin.document.write(response);
                printWin.document.close();

                // Wait for the page to load, and after that we print and close the window
                setTimeout(function() {
                    printWin.focus();
                    printWin.print();
                    printWin.close();
                }, 2000);
            }
        });
    },

    /**
     * @param {String} side
     */
    SwitchSide: function (side) {
        let token = $('[name="_token"]').val();
        this.loadAjax();

        $.ajax({
            type: "POST",
            headers: { 'X-CSRF-TOKEN' : token },
            async: true,
            url: '/customers/switchSide',
            data: {
                side: side
            },
            success:() => {
                location.reload();
            }
        });
    },

    /**
     * @param {String} type
     * @param {String} message
     */
    showNoty: function (type, message, timeout = 5000) {
        new Noty({
            type: type,
            text: message,
            timeout: timeout,
            progressBar: true
        }).show();
    },

    /**
     * @param {String} type
     * @param {String} title
     * @param {String} message
     * @param {function} callback
     * @param {function} denyCallback
     */
    confirm: function(type, title, message, callback, denyCallback) {
        Swal.fire({
            title: title,
            showCancelButton: true,
            html: message,
            icon: type,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                if (callback) {
                    callback();
                }
            },
            preDeny: () => {
                if (denyCallback) {
                    denyCallback();
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        });
    },

    /**
     * This function makes sure the $modal in argument shows on top of other modals (if any)
     * by setting other modals' z-index to 0, and have it reverted back when $modal is hidden.
     *
     * Will only register callback once per $modal instance to prevent unwanted side effect.
     *
     * @param $modal
     * @constructor
     */
    ShowModalOnTop: function ($modal) {
        if ($modal.data("showModalOnTop")) {
            return;
        }

        $modal.on('show.bs.modal', () => {
            let $otherModals = $(".modal.show");
            let otherModalsZIndex = {};

            if ($otherModals.length > 0) {
                $otherModals.each((idx, e) => {
                    otherModalsZIndex[e.id] = $(e).css("zIndex");

                    $(e).css("zIndex", 0);
                });

                $modal.on("hide.bs.modal", e => {
                    $otherModals.each((idx, e) => {
                        $(e).css("zIndex", otherModalsZIndex[e.id]);

                        delete otherModalsZIndex[e.id];
                    });
                });
            }

            $modal.data("showModalOnTop", true);
        });
    }
};

(function initializeDisabledElements(global) {
    var elements = document.getElementsByClassName('disabled');
    if (elements.length) {
        for (let element of elements) {
            element.addEventListener('click', function (evt) {
                if (evt.target.classList.contains('disabled')) {
                    return false;
                }
            });
        }
    }
})(window)

App.init();
